import { ReactNode } from "react"
import { LogLevel } from "../../../api/DTO"

export enum SortBy {
	Newest = 0,
	Oldest = 1,
}

export type DateRange = {
	start: Date
	end: Date
}

type BaseFilterControl = {
	name: string
	type: string
	value?: unknown
	label?: string
	column?: string | string[] // affected column(s), overrides 'name'
	isDisplaySetting?: boolean
	filterEntry?: (entry: unknown, filterValue: unknown) => boolean // custom filtering, overrides 'column' and 'name'
}

type DateFilter = {
	type: 'date range'
	value?: DateRange
} & BaseFilterControl

type SearchFilter = {
	type: 'search'
	value?: string
	placeHolder?: string
} & BaseFilterControl

export type SelectFilter = {
	type: 'select' | 'sort by age' | 'table display'
	value?: string | number
	options?: SelectFilterOption[]
} & BaseFilterControl

export type MultiSelectFilter = {
	type: 'multiselect' | 'log level'
	value?: string [] | number[]
	options?: SelectFilterOption[]
} & BaseFilterControl

export type FilterControl = DateFilter | SearchFilter | SelectFilter | MultiSelectFilter

export type SelectFilterOption = {
	label?: string | number | ReactNode
	value: string | number
}

export type LogFilters = {
	eventId?: string[]
	userId?: number
	logLevel?: LogLevel[]
	eventDate?: { start?: Date, end?: Date }
	sortBy: SortBy
}

export enum TableDisplay {
	Table = 0,
	Json = 1,
}

export enum FilterCalcOrder {
	"date range" = 0,
	"search" = 1,
	"select" = 2,
	"multiselect" = 3,
	"log level" = 4
}